import React, { useContext, useEffect, useState } from "react";
import { CurrentUserContext } from "../../../App";
import * as api from "../../../service/patientApiDev";
import { HashLoader } from "react-spinners";
import styles from "./pagePatient.module.css";
import { useNavigate, useParams } from "react-router-dom";
import iconSuccess from "../../../asset/icon/success.svg";
import Button from "../../material/button/Button";

export default function UpLevelByThaiD() {
  const navigate = useNavigate();
  const { setIsMessage } = useContext(CurrentUserContext);

  const { role, uid } = useParams();
  const [loading, setLoading] = useState(false);
  const [loadingSuccess, setLoadingSuccess] = useState(false);

  useEffect(() => {
    getParameter();
  }, []);

  const getParameter = () => {
    let code = new URLSearchParams(window.location.search).get("code");
    // console.log(code)
    // console.log(role)
    // console.log(uid)
    if (code && role) {
      upLevelThaiD(code, role, uid);
    } else {
      setIsMessage({ type: "warning", data: "code is require." });
    }
  };

  const upLevelThaiD = async (code) => {
    setLoading(true);
    let res = await api.verifyThaiDWithRoleUID(code, role, uid);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setLoadingSuccess(true);
      } else if (res["data"]["code"] === 404) {
        if (role === "PATIENT") {
          navigate("/manageinfo", {
            state: {
              status_message: "Error",
              display_message:
                "ระบบไม่สามารถตรวจสอบ Thaid กรุณาตรวจสอบข้อมูลของคุณอีกครั้ง",
            },
          });
        } else if (role === "MEDICAL_PERSONNEL") {
          navigate("/doctor/ManageInfo", {
            state: {
              status_message: "Error",
              display_message:
                "ระบบไม่สามารถตรวจสอบ Thaid กรุณาตรวจสอบข้อมูลของคุณอีกครั้ง",
            },
          });
        } else if (
          role === "LABORATORY_ADMIN" ||
          role === "LABORATORY_PERSONNEL"
        ) {
          navigate("/laboratory/manageprofileOperation", {
            state: {
              status_message: "Error",
              display_message:
                "ระบบไม่สามารถตรวจสอบ Thaid กรุณาตรวจสอบข้อมูลของคุณอีกครั้ง",
            },
          });
        } else {
          setIsMessage({
            type: "error",
            data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
          });
        }

        //setIsMessage('ไม่พบข้อมูลผู้ใช้งาน กรุณาสมัครใช้งานก่อน')
      } else if (res["data"]["code"] === 401) {
        if (role === "PATIENT") {
          navigate("/manageinfo", {
            state: {
              status_message: "Error",
              display_message:
                res["data"]["message_th"] || res["data"]["message"],
            },
          });
        } else if (role === "MEDICAL_PERSONNEL") {
          navigate("/doctor/ManageInfo", {
            state: {
              status_message: "Error",
              display_message:
                res["data"]["message_th"] || res["data"]["message"],
            },
          });
        } else if (
          role === "LABORATORY_ADMIN" ||
          role === "LABORATORY_PERSONNEL"
        ) {
          navigate("/laboratory/manageprofileOperation", {
            state: {
              status_message: "Error",
              display_message:
                res["data"]["message_th"] || res["data"]["message"],
            },
          });
        } else {
          setIsMessage({
            type: "error",
            data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
          });
        }

        //setIsMessage('ไม่พบข้อมูลผู้ใช้งาน กรุณาสมัครใช้งานก่อน')
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  return (
    <div className={styles.align}>
      {loading ? <Loading loading={loading} /> : ""}
      {loadingSuccess ? (
        <Success
          loading={loadingSuccess}
          role={role}
          setIsMessage={setIsMessage}
        />
      ) : (
        ""
      )}
    </div>
  );
}

const Loading = ({ loading }) => {
  return (
    <>
      <div className={styles.wait}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <HashLoader loading={loading} color="#FF9768" />
        </div>
        <div className={styles.font}>
          <div className={styles.Orange}>กำลังตรวจสอบข้อมูล</div>
          <div className={styles.Orange}>กรุณารอสักครู่</div>
        </div>
      </div>
    </>
  );
};

const Success = ({ role, setIsMessage }) => {
  const [counter, setCounter] = useState(10);
  const navigate = useNavigate();

  const clickNavigate = () => {
    if (role === "PATIENT") {
      navigate("/manageinfo");
    } else if (role === "MEDICAL_PERSONNEL") {
      navigate("/doctor/ManageInfo");
    } else if (role === "LABORATORY_ADMIN" || role === "LABORATORY_PERSONNEL") {
      navigate("/laboratory/manageprofileOperation");
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  useEffect(() => {
    CountNumber();
  }, [counter]);

  const CountNumber = () => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    if (counter === 0) {
      if (role === "PATIENT") {
        navigate("/manageinfo");
      } else if (role === "MEDICAL_PERSONNEL") {
        navigate("/doctor/ManageInfo");
      } else if (
        role === "LABORATORY_ADMIN" ||
        role === "LABORATORY_PERSONNEL"
      ) {
        navigate("/laboratory/manageprofileOperation");
      } else {
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    }
  };
  return (
    <>
      <div className={styles.success}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img src={iconSuccess} />
        </div>
        <div className={styles.font}>
          <div className={styles.Orange}>พิสูจน์ตัวตนด้วย ThaiD สำเร็จ</div>
          <div className={styles.Gray}>
            ระบบจะพาไปยังหน้า “จัดการข้อมูลส่วนตัว” ภายใน {counter} วินาที
          </div>
        </div>
        <div style={{ width: "70%", margin: "auto" }}>
          <Button
            style={{ background: "#FF9768", color: "#FFFFFF", border: "none" }}
            onClick={clickNavigate}
          >
            ไปหน้า จัดการข้อมูลส่วนตัว
          </Button>
        </div>
      </div>
    </>
  );
};
